import { Certificate1Icon } from 'tdesign-icons-vue-next';
import { shallowRef } from 'vue';
import { RouteRecordRaw } from 'vue-router';

export default [
  {
    path: '/warranty',
    component: () => import('@/layouts/index.vue'),
    redirect: '/warranty/warranty-list',
    name: 'warranty',
    meta: {
      title: '质保管理',
      icon: shallowRef(Certificate1Icon),
      orderNo: 7,
      permission: ['WarrantyList'],
    },
    children: [
      {
        path: 'warranty-list',
        name: 'warrantyList',
        component: () => import('@/pages/warranty-management/warranty-list.vue'),
        meta: {
          title: '质保列表',
          permission: ['WarrantyList'],
        },
      },
      {
        path: 'warranty-detail',
        name: 'warrantyDetail',
        component: () => import('@/pages/warranty-management/warranty-detail.vue'),
        meta: {
          title: '质保详情',
          permission: ['WarrantyDetails'],
          hidden: true,
        },
      },
    ],
  },
] as RouteRecordRaw[];
